import * as R from "ramda";
import { message } from "antd";
import { bufferCount, fromEvent, map } from "rxjs";
import React, { useEffect } from "react";


export const checkAutEnabled = (authString) => {
  return !window.actionFor(authString, "boolean");
}

//  gallery-decorate-plus, 高级装修权限
export const hasDecoratePlusAuth = () => {
  // return !window.actionFor("gallery-decorate-plus", "boolean");
  return checkAutEnabled("gallery-decorate-plus");
};

export const hasExhibitorEntryAuth = () => checkAutEnabled("gallery-exhibitor-entry");
export const hasGuestEntryAuth = () => checkAutEnabled("gallery-guest-entry");

export const hasAutoPsAuth = () => {
  // return !window.actionFor("gallery-auto-ps", "boolean");
  return checkAutEnabled("gallery-auto-ps");
};



//  这部分是自己规划的高级配置功能, 目的是给高级管理员提供一些特殊的功能, 并且可以管理
export const SuperAdministratorSetting = () => {
  useEffect(() => {
    const enableText = "enablelinkupload";
    const enableSubscriber = fromEvent(window, "keydown")
      .pipe(
        map(R.prop("key")),
        bufferCount(enableText.length, 1),
        map(R.join(""))
      )
      .subscribe((value) => {
        if (value === enableText) {
          message.success("已开启链接上传, 刷新页面后生效");
        }
      });

    const disableText = "disablelinkupload";
    const disableSubscriber = fromEvent(window, "keydown")
      .pipe(
        map(R.prop("key")),
        bufferCount(enableText.length, 1),
        map(R.join(""))
      )
      .subscribe((value) => {
        if (value === disableText) {
          message.success("已关闭链接上传, 刷新页面后生效");
        }
      });

    return () => {
      enableSubscriber.unsubscribe();
      disableSubscriber.unsubscribe();
    };
  }, []);

  return null;
};



// WEBPACK FOOTER //
// ./src/components/super-administrator-setting/index.js